<div [ngClass]="class" class="border-gray-400">
  <div *ngIf="currentGenres.length;else noGenreTemplate" class="flex flex-wrap">
    <div *ngFor="let genre of currentGenres" class="m-2">
      <button class="bg-primary text-white  border border-primary rounded-md px-4 py-1.5  hover:bg-primary hover:text-white w-full">
        {{ genre.name }}
      </button>
    </div>
  </div>
  <ng-template #noGenreTemplate>
    <div class="text-gray-400 px-4 py-1.5">{{ noGenre }}</div>
  </ng-template>
</div>
<textarea class="hidden" [formControl]="inputControl"></textarea>